/*
 * @Description:
 * @Author: Luke Z
 * @Date: 2021-06-25 18:20:43
 * @LastEditors: Luke Z
 * @LastEditTime: 2021-07-09 11:12:45
 * @FilePath: /unifyxp-v2-store-portal/src/pages/SalesChannelContentEditor/SalesChannelEditorAllProductPage/CloneButton/index.tsx
 */
import React from 'react';
import Button from 'src/components/CloneButton';
import { useDispatch } from 'react-redux';
import { useParams } from 'react-router-dom';
import { fetchContentAllProductsPage } from 'src/pages/SalesChannelContentEditor/SalesChannelEditorAllProductPage/slice';
import { useCloneBtnParams } from 'src/hooks/useCloneBtnParams';

const CloneBtn = (props) => {
  const params: any = useParams();
  const { contentUuid } = params;
  const _d = useDispatch();
  const _params = useCloneBtnParams();

  const handleOnClick = () => {
    _d(
      fetchContentAllProductsPage({
        //1===true 0===false
        uuid: contentUuid,
        params: _params,
        isClone: true,
      }),
    );
  };
  return <Button onClick={handleOnClick} disabled={props?.disabled} />;
};
export default CloneBtn;
